<template>
  <div>
    <Top ref="child" />

    <!-- 标头 -->
    <div class="home mbty">
      <div class="k-dropdown-wrap k-state-default">
        <el-select v-model="countrysmodel" @change="selectcountrys" filterable placeholder="选择经济体" size="medium">
          <el-option v-for="item in countrys" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </div>
      <h2 class="ys_title">
        <span v-if="isNewActive">世行营商环境成熟度（B-READY）数据库</span>
        <span v-if="!isNewActive">DB营商环境数据库</span>
        <!-- <span style="font-size: 16px; font-weight: 400;margin-left: 16px;cursor: pointer;" v-if="isNewActive"
          @click="dialogVisible = true">指标说明</span> -->
          <img style="display: inline;cursor: pointer;" v-if="isNewActive" @click="dialogVisible = true" src="../../assets/imgs/shuoming.png" alt="">
          <!-- <img src="" alt=""> -->
        <router-link v-show="dbusinesss" class="ys_title2"
          :to="{ path: $route.path == '/db/Pillar' || $route.path == '/db/economy' ? '/db/Pillar' : '/db/DbusinessF' }">返回</router-link>
        <!-- <div class="changeDB">
          <span @click="goNew" 
            :class="$route.path == '/db/Pillar' || $route.path == '/db/economy' ? 'change-active' : ''">2024年-今</span>
          <span @click="goOld"
            :class="$route.path == '/db/DbusinessF' || $route.path == '/db/DbusinessS' ? 'change-active' : ''">2020年以前</span>
        </div> -->
        <div class="changeDB">
          <span class="btn-1" @click="goNew" :class="isNewActive ? 'change-active-1' : ''"
            title="（2024-）B-READY营商环境成熟度新评价指标体系">（2024-）B-READY...</span>
          <span class="btn-2" @click="goOld" :class="isOldActive ? 'change-active-2' : ''"
            title="（2004-2020）DB营商环境数据库">（2004-2020）DB营商...</span>
        </div>
      </h2>
      <el-dialog title="" :visible.sync="dialogVisible" width="80%" top="10vh" :before-close="handleClose"
        custom-class="custom-dialog">
        <div class="dialog-content">
          <h1 style="text-align: center;margin-bottom: 16px;">世界银行营商环境成熟度（B-READY）指标说明</h1>
          <p style="margin-bottom:16px">
            <span style="font-weight: bold;">世界银行营商环境成熟度（B-READY）</span>项目评估各经济体的营商环境，重点关注监管框架、为企业与市场提供的相关公共服务，以及监管框架与公共服务在实践中相结合的办事效率。世界银行营商环境成熟度评估体系在评估营商环境时采用一种较为平衡的方式，力求在开展业务的便利度与实现更广泛的私营部门利益之间、监管框架与公共服务之间、法律法规与实际执行之间，以及数据的代表性与数据可比性之间找到平衡。世界银行营商环境成熟度评估体系共包括10个一级指标、30个二级指标、82个三级指标、245个四级指标和798个测评点，涉及1692个问题（其中379个问题不计分）。<span style="text-decoration: underline;">各级指标、数据来源和评分方法相对旧的DB评估体系有较大变化。</span>
          </p>
          <p >
            世界银行营商环境成熟度评估体系采用<span style="font-weight: bold;">专家咨询和企业调查两种主要方式收集数据。专家咨询</span>主要用于评估监管框架和公共服务，通常集中在经济体人口最多的城市进行，专家问卷每年开展一次；企业调查则主要用于评估运营效率，评估团队通过随机抽样来选择被调查企业，企业调查每3年才被要求开展一次。在总分构成上，2025年的报告显示，专家咨询占约66.6%，企业调查占约33.3%。
          </p>
          <img src="../../assets/imgs/shuoming2026.png" alt="" style="display: block;margin: 0 auto;">
          <h3 style="text-align: center;margin-bottom: 16px;">图1：世界银行营商环境成熟度（B-READY）评估体系涉及的主题</h3>
          <h3 style="margin-bottom:8px">（一）核心评估框架</h3>
          <p>以三大支柱为核心，覆盖企业从开业、运营和扩张到关闭（或重组）全生命周期，兼顾企业发展与社会效益，是本次数据库迭代的核心依据。</p>
          <table border="1" class='styled-table' style="margin-bottom: 16px;">
            <thead>
              <tr>
                <th width="160">核心支柱</th>
                <th>核心内涵</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>监管框架</td>
                <td>考量监管的质量，通过与国际公认的最佳实践进行比较，考察监管的透明度、明确性及可预测性，重点关注相关政策是否出台及政策的具体内容；</td>
              </tr>
              <tr>
                <td>公共服务</td>
                <td>考量政府直接提供或委托相关私营公司提供的公共服务，及其机构设置、基础设施、公共项目等，着重于评价政策如何落实以及是否容易落实；</td>
              </tr>
              <tr>
                <td>实施效率</td>
                <td>衡量在相关监管框架和公共服务下，私营部门获得公共服务的效率，着重于市场主体的获得感。</td>
              </tr>
            </tbody>
          </table>
          <h3 style="margin-bottom:8px">（二）十大核心主题（一级指标）</h3>
          <p style="padding: 0 20px;margin-bottom:8px">覆盖企业从开业、运营和扩张到关闭（或重组）全生命周期，是数据库核心展示维度：</p>
          <ol style="padding: 0 28px;margin-bottom: 16px;" >
            <li style="margin-bottom:8px"><span style="font-weight: bold;">企业准入（Business Entry）：</span><span>反映了企业设立和运营的难易程度，比如更完善的法律体系、更高效的政府服务、更加稳定和透明的营商环境；</span></li>
            <li style="margin-bottom:8px"><span style="font-weight: bold;">经营场所（Business Location）：</span><span>企业设立和运营过程中的重要环节，如完善的城市规划、高效的土地管理和便捷的交通网络；</span></li>
            <li style="margin-bottom:8px"><span style="font-weight: bold;">公用服务设施（Utility Services）：</span><span>企业运营的重要支撑，包括水、电、燃气、通信和交通等，如更加完善的基础设施网络、更加高效的公共服务体系、更加稳定和可靠的基础设施服务；</span></li>
            <li style="margin-bottom:8px"><span style="font-weight: bold;">劳动力（Labor）：</span><span>企业运营的关键因素之一，如高素质的劳动力资源、完善的劳动力市场体系和高效的劳动法规；</span></li>
            <li style="margin-bottom:8px"><span style="font-weight: bold;">金融服务（Financial Services）：</span><span>企业运营的重要支撑之一，如更加完善的金融体系、更加高效的金融机构、更加稳定和高效的金融服务；</span></li>
            <li style="margin-bottom:8px"><span style="font-weight: bold;">国际贸易（International Trade）：</span><span>企业拓展市场和获取资源的重要途径，如更加完善的国际贸易体系、更加高效的国际贸易规则、更加稳定和高效的国际贸易环境；</span></li>
            <li style="margin-bottom:8px"><span style="font-weight: bold;">纳税（Taxation）：</span><span>企业运营的重要成本之一，如更加透明的税收制度、更加高效的税收管理、更加稳定和可预测的税收环境；</span></li>
            <li style="margin-bottom:8px"><span style="font-weight: bold;">争端解决（Dispute Resolution）：</span><span>企业运营过程中不可避免的问题，如更加完善的法律体系、更加高效的司法机构、更加稳定和高效的争议解决环境；</span></li>
            <li style="margin-bottom:8px"><span style="font-weight: bold;">市场竞争（Market Competition）：</span><span>企业发展的重要动力之一，如更加完善的市场竞争体系、更加高效的监管机构、更加稳定和高效的市场竞争环境；</span></li>
            <li style="margin-bottom:8px"><span style="font-weight: bold;">企业破产（Business Insolvency）：</span><span>企业运营过程中可能面临的风险之一，如更加完善的企业破产制度、更加高效的破产管理机构、更加稳定和高效的企业破产环境。</span></li>
          </ol>
          <!-- <h3>（三）核心特点</h3>
          <ul style="padding: 0 20px;;margin-bottom: 16px;">
            <li>更重实际落地：不仅考察法规条文，更聚焦企业实际经营体验；</li>
            <li>数据来源多元：结合专家问卷、企业实地调研，数据更精准；</li>
            <li>覆盖范围聚焦：首批2024年覆盖50个核心经济体，2025年增加52个经济体，2026年增加63个经济体，2027年增加15个经济体，共计180个经济体，其中涵盖多个“一带一路”共建国家；</li>
            <li>评估维度全面：新增公共服务、数字化、可持续性等前沿维度。</li>
          </ul> -->
        </div>
      </el-dialog>
    </div>
    <router-view></router-view>
    <backTop />
    <Footer />
  </div>
</template>

<script>
import Top from "@/components/top";
import Footer from "@/components/footer";
import backTop from "@/components/BackTop";
import { api } from "@/require/api";

export default {
  data() {
    return {
      countrysmodel: "",
      selectcountry: "", //下拉所有区域value
      countrys: [], ///下拉值
      dbusinesss: false, //头部返回到营商二级页面
      isNewActive: true,
      isOldActive: false,
      dialogVisible: false
    };
  },
  components: {
    Top,
    Footer,
    backTop
  },
  created() {

  },
  mounted() {
    // 顶部查询显示
    this.$refs.child.isShowsearch = false;
    this.$refs.child.ischannelright = true;
    this.loadselectdata(); //加载经济体下拉

    this.loadselectstyle(); //经济体选择框样式

    this.isShowBack();

  },
  activated() {
    this.isShowBack();
    // this.loadselectdata();
  },
  methods: {
    //经济体选择框样式
    loadselectstyle() {
      this.isShowBack();
      $(".k-dropdown-wrap  .el-input__inner").addClass(
        "el-input__inner_country"
      );
    },
    isShowBack() {
      if (this.$route.query.countryid != undefined) this.dbusinesss = true;
      else this.dbusinesss = false;
    },
    //加载经济体下拉
    async loadselectdata() {
      this.countrys = []
      if (this.$route.path == '/db/Pillar' || this.$route.path == '/db/economy') {

        var { code, data } = await api.get(
          "/doingBusiness2026Controller/getTimesAndCountrys"
        );
      } else {

        var { code, data } = await api.get(
          "/doingBusinessController/getTimesAndCountrys"
        );
      }

      if (code === 0) {
        this.countrysmodel = "选择经济体";
        if (data.countryNames[0].name == "全部经济体") //因为接口中有"全部经济体"，因此需要去掉
          data.countryNames.splice(0, 1);
        this.countrys = data.countryNames; //下拉值
      }
    },
    //经济体选择后
    selectcountrys(value) {
      this.selectcountry = value;
      if (this.$route.path == '/db/Pillar' || this.$route.path == '/db/economy') {
        this.$router.push({
          path: "/db/economy",
          query: { countryid: this.selectcountry }
        });

      } else {
        this.$router.push({
          path: "/db/DbusinessS",
          query: { countryid: this.selectcountry }
        });

      }

    },
    goNew() {
      setTimeout(() => {
        this.loadselectdata();
      }, 300);
      this.$router.push({
        path: "/db/Pillar"
      });
      this.isNewActive = true
      this.isOldActive = false

    },
    goOld() {
      setTimeout(() => {
        this.loadselectdata();
      }, 300);
      this.$router.push({
        path: "/db/DbusinessF"
      });
      this.isNewActive = false
      this.isOldActive = true
    },
    openExplanation() {
      this.$alert('', 'HTML 片段111', {
        dangerouslyUseHTMLString: true,
        customClass: 'custom-alert-style', // 自定义类名
        showConfirmButton: true // 可选：显示确认按钮（默认可能隐藏）
      });
    }
  },
  watch: {
    '$route': {
      immediate: true,  // 关键：初始化时立即执行
      handler(newPath, oldPath) {
        this.$nextTick(() => {
          this.isShowBack();
        });
      }
    },
    // isNewActive: {
    //   immediate: true,  // 关键：初始化时立即执行
    //   handler(newPath, oldPath) {
    //     setTimeout(() => {
    //        //加载经济体下拉
    //     }, 300);
    //   }
    // }
  }
};
</script>

<style lang='less' scoped>
/deep/.guides {
  display: none !important;
}

// 标头
.mbty {
  background: #fff;
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.05);
  height: 55px;
}

.bt_title {
  color: #1260af;
  line-height: 160%;
  position: relative;
  text-align: center;
  display: block;
  font-weight: bold;
  height: 55px;
  line-height: 55px;
  font-size: 22px;
  box-sizing: border-box;
}

// 经济体下拉

.k-dropdown-wrap {
  width: 210px;
}

.k-state-default {
  position: absolute;
  height: 40px;
  line-height: 38px;
  border: 0px;
  border-radius: 0px;
  text-align: left;
  background-color: #1583cc;
  color: #ffffff;
  -webkit-box-shadow: none;
  box-shadow: none;
  float: left;
  background-image: none;
  margin-top: 7px;
  margin-left: 10px;
}

.k-input {
  font-size: 14px;
  line-height: 24px;
  color: #fff;
  padding-left: 20px;
  position: relative;
}

.k-select {
  width: 2.6em;
}

.k-select {
  position: absolute;
  right: 0;
  display: inline-block;
}

.k-icon {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 1em;
  height: 1em;
  text-align: center;
  vertical-align: middle;
  background: url(../../assets/imgs/drop-down1.png) no-repeat center;
  font: 16px/1 WebComponentsIcons;
  font-variant-caps: normal;
  font-weight: normal;
  font-family: WebComponentsIcons;
  font-variant-alternates: normal;
  font-variant-east-asian: normal;
  font-variant-ligatures: normal;
  font-variant-numeric: normal;
  font-variant-position: normal;
  speak: none;
  font-variant: normal;
  text-transform: none;
  text-indent: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
}

/deep/ .el-input__inner_country {
  background-color: #1583cc !important;
  border: none !important;
  color: #fff !important;
}

.ys_title {
  color: #1260af;
  line-height: 160%;
  // text-align: center;
  padding-left: 20%;
  display: block;
  font-weight: bold;
  height: 55px;
  line-height: 55px;
  font-size: 22px;
  box-sizing: border-box;
}

.ys_title2 {
  color: #1260af;
  font-weight: normal;
  font-size: 16px;
  margin-left: 20px;
}

.changeDB {
  float: right;
  margin-right: 20px;

  span {
    display: inline-block;
    border: 2px solid #ddd;
    font-size: 14px;
    margin-left: 16px;
    line-height: 30px;
    padding: 0 16px;
    cursor: pointer;


  }

  .btn-1 {
    border: 2px solid #bad9ff;
    background-color: #eef5fe;
    color: #1447e6;
    border-radius: 5px;

    &:hover {
      background-color: #6080df;
      color: #fff;
    }
  }

  .btn-2 {
    border: 2px solid #9af2ca;
    background-color: #ecfdf5;
    color: #009866;
    border-radius: 5px;

    &:hover {
      background-color: #009866;
      color: #fff;
    }
  }

  .change-active-1 {
    background-color: #6080df;
    color: #fff;
    border: 2px solid #6080df;
  }

  .change-active-2 {
    background-color: #009866;
    color: #fff;
    border: 2px solid #009866;
  }
}

.custom-dialog {
  max-height: 80vh;
  /* 最大高度 */
  overflow: hidden;
  /* 隐藏溢出内容 */
}

/* 弹窗内容区域样式 */
.dialog-content {
  padding: 20px;
  max-height: 60vh;
  /* 内容区域高度 */
  overflow-y: auto;
  /* 滚动条 */
  text-align: left !important;
  padding: 16px;
}

.styled-table {
  width: 100%;
  /* 表格宽度100% */
  border-collapse: collapse;
  /* 合并边框 */
  margin: 20px 0;
  /* 外边距 */
  font-family: Arial, sans-serif;
  /* 字体 */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* 轻微阴影 */
}

/* 表头样式 */
.styled-table thead tr {
  background-color: #4CAF50;
  /* 表头背景色（绿色） */
  color: white;
  /* 表头文字颜色 */
  text-align: left;
  /* 文字左对齐 */
}

/* 表头单元格样式 */
.styled-table th {
  padding: 12px 15px;
  /* 内边距 */
  font-weight: bold;
  /* 加粗 */
}

/* 表格内容样式 */
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
  /* 行间分隔线 */
  transition: background-color 0.2s;
  /* 悬停过渡效果 */
}

/* 表格内容单元格样式 */
.styled-table td {
  padding: 10px 15px;
  /* 内边距 */
}

/* 表格行悬停效果 */
.styled-table tbody tr:hover {
  background-color: #f5f5f5;
  /* 悬停背景色 */
}

/* 斑马条纹效果（可选） */
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
  /* 偶数行背景色 */
}
</style>